import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    EmailField,
    TextInput,
    FilterButton,
    CreateButton,
    ExportButton,
    TopToolbar,
    Show, 
    SimpleShowLayout,
    DateField,
    ChipField,
    useRecordContext,
    ListButton,
    Link
} from 'react-admin';
import { Chip, Button } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import { CustomerAvatar } from "../Users/CustomerAvatar";

const StatusChipField = ({ source }) => {
    const record = useRecordContext();
    if (!record) return <span>No record</span>;
    const status = record[source];
    if (status === undefined || status === null) return <span>No status</span>;
    const statusNumber = typeof status === 'string' ? parseInt(status) : status;
    const color = statusNumber === 200 ? 'success' : 'error';
    return (
        <Chip 
            label={statusNumber} 
            color={color} 
            size="small"
            variant="filled"
        />
    );
};

const BodyField = ({ source, truncate = false }) => {
    const record = useRecordContext();
    if (!record || !record[source]) return <span>-</span>;
    
    let bodyContent = record[source];
    
    try {
        const jsonData = JSON.parse(bodyContent);
        if (jsonData.password !== undefined) {
            const maskedData = { ...jsonData, password: '******' };
            bodyContent = JSON.stringify(maskedData, null, 2);
        }
    } catch (error) {}
    
    const displayContent = truncate && bodyContent.length > 120
        ? bodyContent.substring(0, 120) + '...'
        : bodyContent;

    return (
        <pre style={{ 
            whiteSpace: 'pre-wrap', 
            wordBreak: 'break-word',
            fontSize: '12px',
            overflow: 'auto',
            margin: 0
        }}>
            {displayContent}
        </pre>
    );
};

const UserEmailLink = () => {
    const record = useRecordContext();
    if (!record?.email) return null;
    const filter = encodeURIComponent(JSON.stringify({ q: record.email }));
    return (
        <Button
            component={Link}
            to={`/users?filter=${filter}`}
            size="small"
            startIcon={<PeopleIcon />}
            variant="outlined"
            sx={{ mt: 1 }}
        >
            Ver usuario: {record.email}
        </Button>
    );
};

StatusChipField.displayName = 'StatusChipField';
BodyField.displayName = 'BodyField';
UserEmailLink.displayName = 'UserEmailLink';

const Filters = [
    <TextInput source="q" label="Buscar" alwaysOn />,
    <TextInput source="email" label="Email" />,
    <TextInput source="source" label="Source" />,
    <ChipField source="status" label="Status" />,
    <DateField source="date" label="Date" showTime/>,
];

const ListActions = () => (
    <TopToolbar>
        <FilterButton />
        <CreateButton />
        <ExportButton />
    </TopToolbar>
);

export const LogsList = () => (
    <List
        filters={Filters}
        actions={<ListActions />}
        perPage={50}
        sort={{ field: 'date', order: 'DESC' }}
    >
        <Datagrid>
            <TextField source="id" />
            <CustomerAvatar size="small" />
            <EmailField source="email" label="Email / UserID" />
            <TextField source="source" label="Source" />
            <StatusChipField source="status" label="Status" />
            <BodyField source="body" label="Body" truncate={true} />
            <DateField source="date" label="Date" showTime/>
        </Datagrid>
    </List>
);

const ShowActions = () => (
    <TopToolbar>
        <ListButton label="Volver a logs" />
    </TopToolbar>
);

export const LogsShow = () => {
    return (
        <Show actions={<ShowActions />}>
            <SimpleShowLayout>
                <TextField source="id" />
                <CustomerAvatar size="small" />
                <EmailField source="email" label="Email" />
                <UserEmailLink />
                <TextField source="source" label="Source" />
                <StatusChipField source="status" label="Status" />
                <BodyField source="body" label="Body" truncate={false} />
                <DateField source="date" label="Date" showTime/>
            </SimpleShowLayout>
        </Show>
    );
};